import * as React from "react"

function PointerSvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16.828}
      viewBox="0 0 16 16.828"
      {...props}
    >
      <g
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path data-name="Line 329" stroke={props.lineFill} d="M1 8.414h14" />
        <path data-name="Path 26214" d="M8 1.414l7 7-7 7" stroke={props.arrowFill} />
      </g>
    </svg>
  )
}

export default PointerSvgComponent
